export const DEFAULT_LOCALE = typeof window !== 'undefined' ? window.navigator?.language || 'en-US' : 'en-US';
